import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AdminService } from '../services/admin.service';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'admin-view-user-details',
    templateUrl: 'view-user-details.component.html'
})

export class AdminViewUserDetailsComponent implements OnInit{

    vUserid: number;
    sub: any;

    constructor(
        private _adminService: AdminService,
        private _layoutService: LayoutService,
        private _activatedRoute: ActivatedRoute,
        private _pageNavigationService: PageNavigationService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('admin-view-user-details');
        this.sub = this._activatedRoute.params.subscribe(params => {
            this.vUserid = +params['userid'];
        });
        
        this._adminService.resetUserDetailsData();
        this._adminService.resetError();

        this._adminService.loadInternalRoles();
        this._adminService.loadUserDetails(this.vUserid);
    }

    getUserDetailsData(){
        return this._adminService.getUserDetailsData();
    }

    getInternalRoles(){
        return this._adminService.getInternalRoles();
    }

    isUserEditable(){
        return this._adminService.isUserEditable();
    }

    isLoading(){
        return this._adminService.isLoading();
    }

    close(){
        this._pageNavigationService.navigate(['user-account']);
    }

    resetUserPassword(){
        this._adminService.resetUserPassword();
    }
    
    updateUser(){
        this._adminService.updateUser();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/components/view-user-details.component.ts